var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1A8FD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7827 22.1813C46.621 22.6974 45.3728 23.0446 44.0628 23.2013C45.4007 22.3999 46.4265 21.1314 46.9096 19.6187C45.6591 20.3606 44.2729 20.8995 42.7963 21.1909C41.6151 19.9319 39.9325 19.1451 38.07 19.1451C33.9532 19.09 30.7882 23.1119 31.7623 27.096C26.3804 26.8264 21.6092 24.2478 18.4139 20.3286C16.67 23.1724 17.6601 27.2391 20.4185 28.9752C19.3574 28.9412 18.3581 28.6498 17.4853 28.1653C17.4449 31.329 19.6892 34 22.6802 34.5961C21.7612 34.8524 20.7024 34.8925 19.7555 34.7076C20.58 37.28 22.9716 39.1534 25.8051 39.2054C23.2432 41.2526 19.6566 42.3198 16.2168 41.8874C30.0487 50.3999 45.3395 39.2473 44.55 25.533C45.8158 24.6191 46.9147 23.4791 47.7827 22.1813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.1e81f8b5d3844396820ca8500e8af517.svg";
export { ForwardRef as ReactComponent };